export const en = {
  "title": "Khizhniak Anna - Portfolio",
  "name": "Khizhniak Anna",
  "portfolio": "Portfolio",
	"small": "Small tasks",
  "cv": "CV",
  "edu": "Education/Experience",
  "openProject": "Open project",
  "descProjectHobbyart": "frontend+backend. node.js+vue.js. flexbox, grid, javascript, swippers, switcher, mobile view, animation",
  "descProjectHillel": "flexbox, jquery, swippers, switcher, mobile view, modal, regexp, form validation",
  "descProjectLocalize": "flexbox, mobile view, jquery",
  "descProjectMeliorit": "flexbox, jquery, swippers, mobile view",
  "descProjectBeauty": "flexbox, jquery, modal, mobile view",
  "descProjectFoxDigital": "flexbox, jquery, java script, swippers, switcher for 2 color schemes, mobile view",
  "descProjectFutureAcademy": "java script, flexbox, grid, bootstrap, swiper, tabs",
  "descProjectWPMeliorit": "wordpress, flexbox, jquery, swippers, mobile view",
  "smallUserListLabel": "User list",
  "smallPromoLabel": "Promo-code generator",
  "smallExchangeLabel": "Currency exchange",
	"smallSpinWheelLabel": "Spin wheel",
	"smallDeckCardsLabel": "Deck of cards",
	"smallDashboardLabel": "Dashboard",
  "experienceLabel": "Experience",
  "educationLabel": "Education",
  "viewDetails": "View details"
}



